<style scoped>
.live-loader {
  color: #ffffff;
  font-size: 25px;
}

@media (max-width: 400px) {
  .live-loader {
    font-size: 18px;
  }
}
</style>
<template>
  <div>
    <svg
      xml:space="preserve"
      viewBox="0 0 100 100"
      y="0"
      x="0"
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      version="1.1"
      style="height: 35px; width: 35px; margin-bottom: 8px"
      width="32px"
      height="32px"
    >
      <g
        class="ldl-scale"
        style="transform-origin: 50% 50%; transform: rotate(0deg) scale(1, 1)"
      >
        <g class="ldl-ani">
          <g class="ldl-layer">
            <g
              class="ldl-ani"
              style="
                transform-origin: 50px 50px;
                transform: scale(0.91);
                animation: 1.11111s linear -0.462222s infinite normal forwards running
                  breath-3e311853-5f40-4fac-bbb1-bfe7d5a85df4;
              "
            >
              <path
                stroke-miterlimit="10"
                :fill="liveColor"
                :stroke="liveColor"
                stroke-width="3.5"
                d="M54.523 89.999h-9.046c-3.209 0-5.567-3.011-4.797-6.126l4.523-17.308A4.94 4.94 0 0 1 50 62.809h0a4.942 4.942 0 0 1 4.797 3.756l4.523 17.308c.769 3.115-1.588 6.126-4.797 6.126z"
                :style="`fill: ${liveColor}; stroke: red;`"
              ></path>
            </g>
          </g>
          <g class="ldl-layer">
            <g
              class="ldl-ani"
              style="
                transform-origin: 50px 50px;
                transform: scale(0.91);
                animation: 1.11111s linear -0.624444s infinite normal forwards running
                  breath-3e311853-5f40-4fac-bbb1-bfe7d5a85df4;
              "
            >
              <circle
                stroke-miterlimit="10"
                fill="#f0af6b"
                stroke="#333"
                stroke-width="3.5"
                r="7.738"
                cy="50"
                cx="50"
                :style="`fill: ${liveColor}; stroke: ${liveColor};`"
              ></circle>
            </g>
          </g>
          <g class="ldl-layer">
            <g
              class="ldl-ani"
              style="
                transform-origin: 50px 50px;
                transform: scale(0.91);
                animation: 1.11111s linear -0.786667s infinite normal forwards running
                  breath-3e311853-5f40-4fac-bbb1-bfe7d5a85df4;
              "
            >
              <path
                stroke-linecap="round"
                stroke-width="3.5"
                stroke-linejoin="round"
                stroke="#333"
                fill="none"
                d="M67.025 86.199C80.601 79.802 90 66.001 90 50c0-21.434-16.859-38.928-38.039-39.95-.65-.032-1.303-.05-1.961-.05s-1.311.018-1.961.05C26.859 11.072 10 28.566 10 50c0 16.001 9.399 29.802 22.975 36.199"
                :style="`stroke: ${liveColor};`"
              ></path>
            </g>
          </g>
          <!--                <g class="ldl-layer">-->
          <!--                    <g class="ldl-ani" style="transform-origin: 50px 50px; transform: scale(0.91); animation: 1.11111s linear -0.948889s infinite normal forwards running breath-3e311853-5f40-4fac-bbb1-bfe7d5a85df4;">-->
          <!--                        <path stroke-linecap="round" stroke-width="3.5" stroke-linejoin="round" stroke="#333" fill="none" d="M64.542 76.24C73.76 71.12 80 61.291 80 50c0-16.393-13.151-29.706-29.477-29.987C50.349 20.01 50.176 20 50 20s-.349.01-.523.013C33.151 20.294 20 33.607 20 50c0 11.291 6.24 21.12 15.458 26.24" style="stroke: rgb(255 255 255);"></path>-->
          <!--                    </g>-->
          <!--                </g>-->
          <!--                <g class="ldl-layer">-->
          <!--                    <g class="ldl-ani" style="transform-origin: 50px 50px; transform: scale(0.91); animation: 1.11111s linear -1.11111s infinite normal forwards running breath-3e311853-5f40-4fac-bbb1-bfe7d5a85df4;">-->
          <!--                        <path stroke-linecap="round" stroke-width="3.5" stroke-linejoin="round" stroke="#333" fill="none" d="M38.015 65.984C33.157 62.335 30 56.543 30 50c0-9.996 7.341-18.255 16.921-19.739C47.927 30.105 48.95 30 50 30s2.073.105 3.079.261C62.659 31.745 70 40.004 70 50c0 6.543-3.157 12.335-8.015 15.984" style="stroke: rgb(255 255 255);"></path>-->
          <!--                    </g>-->
          <!--                </g>-->
        </g>
      </g>
    </svg>
    <span class="live-loader">LIVE</span>
  </div>
</template>

<script>
export default {
  name: "EventLiveLoader",
  props: ["color"],
  data() {
    return {
      liveColor: this.color,
    };
  },
};
</script>
